module.exports = __webpack_public_path__ + "food-48.b85f31d09d3780b3c60c.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/food/webfont/food-48.svg
// module id = ../../../../../src/assets/fonts/line-icons-pro/food/webfont/food-48.svg
// module chunks = styles